import { useEffect, useEffectEvent } from 'react';
import { CHAT_INPUT_MODES, ChatAPI } from '@guuru/chat-web';

// Every time the inputMode changes we need to recalculate
// the handleInput and check if the user had any pending messages
const useUpdateInputBar = (chatId, inputMode, text, handleInput) => {
  const updateInput = useEffectEvent(() => {
    let lastInput = text;
    if (inputMode === CHAT_INPUT_MODES.chat && chatId) {
      lastInput = ChatAPI.storeRetrieveChatUserPendingInput(chatId) ?? '';
    }
    handleInput(lastInput, false);
  });

  useEffect(() => updateInput(), [inputMode, chatId]);
};

export default useUpdateInputBar;
